<template>
    <div id="filter_general"
        :style="style.width < 470 ? {textAlign: 'right'} : {}">

        <div class="ui action input" v-if="!filter.is_advanced_mode">
            <HeaderInputs
                v-if="style.width > 470"
            >
            </HeaderInputs>

            <!--
            * ========================================================================
            * = quick keys dropdown
            * ========================================================================
            -->
            <div class="ui selection dropdown no_search right_radius"
                style="min-width:120px;"
                v-dropdown>
                <div class="text"
                    v-for="item in filter.shortcut_keys"
                    v-if="filter.current_shortcut_key == item">
                    <span>
                        {{ $t('ui.pages.driver_commissions.'+(item == 'staff_identity' ? 'driver': item)) }}
                    </span>
                </div>
                <div class="menu">
                    <div class="item"
                        v-for="item in filter.shortcut_keys"
                        :class="{'selected active': filter.current_shortcut_key == item }"
                        >
                        {{ $t('ui.pages.driver_commissions.'+(item == 'staff_identity' ? 'driver': item)) }}
                    </div>
                </div>
            </div>
            <div class="ui button icon" @click="$parent.$parent.driver_commissions_filter()">
                <i class="search icon"></i>
            </div>
        </div>

        <div class="ui action input"
            v-if="!filter.is_advanced_mode &&
                style.width < 470 &&
                filter.current_shortcut_key != 'is_done' &&
                filter.current_shortcut_key != 'is_canceled'"
            style="padding-top: 9px; width:100%">
            <HeaderInputs>
            </HeaderInputs>
        </div>

    </div>
</template>

<script>
import HeaderInputs from './header_inputs.vue'

export default {
    name: "OperationsFilterHeader",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_store() {
            return this.$store.state.provider.driver_commissions_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        HeaderInputs
    }
}
</script>

<style scoped lang="scss">

</style>
